// frontend/src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router.js";
// import axios from 'axios';  // 已改用 api.js 中的 axios 實例，暫時註解

// 創建 Vue 應用實例
const app = createApp(App);

// 以下 axios 相關設定已移至 api.js 進行統一管理，暫時註解保留
// 將 axios 添加為全域屬性
// app.config.globalProperties.$http = axios;

// 動態設定 API 基礎 URL
// const getApiBaseUrl = () => {
//   // 如果有環境變數就使用環境變數
//   if (process.env.VUE_APP_API_BASE_URL) {
//     return process.env.VUE_APP_API_BASE_URL;
//   }
//   
//   // 否則根據當前主機動態設定
//   const hostname = window.location.hostname;
//   if (hostname === 'localhost' || hostname === '127.0.0.1') {
//     return 'http://localhost:8000/api';
//   } else {
//     return `http://${hostname}:8000/api`;
//   }
// };

// axios.defaults.baseURL = getApiBaseUrl();
// axios.defaults.timeout = 10000;

// 使用路由並掛載應用
app.use(router).mount("#app");